export const defaultCards = [
  {
    id: "card-765549",
    question: "What is Rylie's favorite color?",
    answer: "Yellow!",
    tags: ["personal", "colors"],
    isBookmarked: false,
  },
  {
    id: "card-543764",
    question: "What is Rylie's dog called?",
    answer: "Karlchen!",
    tags: ["personal", "animals", "pets"],
    isBookmarked: false,
  },
  {
    id: "card-865468",
    question: "Which mamal glows in the dark?",
    answer: "the platypus",
    tags: ["animals", "fun facts"],
    isBookmarked: false,
  },
  {
    id: "card-487593",
    question: "What was the former name of the German city Chemnitz?",
    answer: "Karl-Marx-Stadt (Karl Marx City)",
    tags: ["travel", "fun facts"],
    isBookmarked: false,
  },
  {
    id: "card-295938",
    question: "What does every state array need?",
    answer: "Keys",
    tags: ["programming", "React.js"],
    isBookmarked: false,
  },
  {
    id: "card-27294629",
    question: "What is Rylie's favorite beer?",
    answer: "Sternburg Export",
    tags: ["personal"],
    isBookmarked: false,
  },
  {
    id: "card-1038219",
    question:
      "What is the name of the main character of Orange Is The New Black (Netflix)?",
    answer: "Piper Chapman",
    tags: ["Netflix", "queer"],
    isBookmarked: false,
  },
  {
    id: "card-3820463",
    question: "What was the first gay married couple in Spain named?",
    answer: "Elisa and Marcella",
    tags: ["queer", "history", "travel"],
    isBookmarked: false,
  },
  {
    id: "card-283476",
    question: "True or False: React is a framework.",
    answer: "False. React is a library for Java Script.",
    tags: ["programming", "React.js"],
    isBookmarked: false,
  },
  {
    id: "card-8723103",
    question: "Which city is the cultural capital of Europe in 2025?",
    answer: "Chemnitz, Germany",
    tags: ["travel", "fun facts"],
    isBookmarked: false,
  },
  {
    id: "card-87234632",
    question:
      "What is the name of the blue alien species in Rick and Morty that tries to fulfill their purpose as fast as possible to stop existing?",
    answer: "Meeseeks",
    tags: ["Netflix", "cartoons"],
    isBookmarked: false,
  },
  {
    id: "card-32248253",
    question: "What is the answer to everything?",
    answer: "42",
    tags: ["fun facts"],
    isBookmarked: false,
  },
  {
    id: "card-32876242",
    question: "What is the Japanese capital city?",
    answer: "Tokyo",
    tags: ["travel", "Japanese"],
    isBookmarked: false,
  },
  {
    id: "card-5342819",
    question: "What is Rylie's favorite thing to do besides coding?",
    answer: "making music and songwriting",
    tags: ["personal"],
    isBookmarked: false,
  },
  {
    id: "card-4632910",
    question:
      "True or False: People with blue eyes can see better in the dark.",
    answer: "True. Though they are more sensitive to light during the day too.",
    tags: ["fun facts"],
    isBookmarked: false,
  },
];
